import { CurrentAction, PageState, State } from "../state";

export interface MouseLeaveAction {
  type: "MOUSE LEAVE";
}

const mouseLeaveOnPage = (state: PageState, _: MouseLeaveAction): PageState => {
  if (
    state.currentAction !== CurrentAction.HOVERING_NOTHING ||
    state.previousMouseLocation ||
    state.selection
  ) {
    return {
      ...state,
      currentAction: CurrentAction.HOVERING_NOTHING,
      firstDragEvent: false,
      hoveredZone: -1,
      previousMouseLocation: null,
      selection: null,
    };
  }
  return state;
};

export const mouseLeave = (state: State, action: MouseLeaveAction): State => {
  const updatedPage = mouseLeaveOnPage(state.pages[state.activePage], action);
  if (updatedPage === state.pages[state.activePage]) {
    return state;
  }
  return {
    ...state,
    pages: [
      ...state.pages.slice(0, state.activePage),
      updatedPage,
      ...state.pages.slice(state.activePage + 1),
    ],
  };
};
